// AUTO-GENERATED by scripts/gen-callout-colors — do not edit by hand.
// Literal Tailwind class strings for every color in the v4 palette so the
// scanner can detect them in the published dist (template-built names are
// invisible to Tailwind's JIT). Regenerate after changing the palette.
import type { Color } from "../../utils/types";

export const calloutContainer: Record<Color, string> = {
  slate: "border-slate-500 bg-slate-50 text-slate-900 dark:border-slate-400 dark:bg-slate-950/50 dark:text-slate-100",
  gray: "border-gray-500 bg-gray-50 text-gray-900 dark:border-gray-400 dark:bg-gray-950/50 dark:text-gray-100",
  zinc: "border-zinc-500 bg-zinc-50 text-zinc-900 dark:border-zinc-400 dark:bg-zinc-950/50 dark:text-zinc-100",
  neutral: "border-neutral-500 bg-neutral-50 text-neutral-900 dark:border-neutral-400 dark:bg-neutral-950/50 dark:text-neutral-100",
  stone: "border-stone-500 bg-stone-50 text-stone-900 dark:border-stone-400 dark:bg-stone-950/50 dark:text-stone-100",
  red: "border-red-500 bg-red-50 text-red-900 dark:border-red-400 dark:bg-red-950/50 dark:text-red-100",
  orange: "border-orange-500 bg-orange-50 text-orange-900 dark:border-orange-400 dark:bg-orange-950/50 dark:text-orange-100",
  amber: "border-amber-500 bg-amber-50 text-amber-900 dark:border-amber-400 dark:bg-amber-950/50 dark:text-amber-100",
  yellow: "border-yellow-500 bg-yellow-50 text-yellow-900 dark:border-yellow-400 dark:bg-yellow-950/50 dark:text-yellow-100",
  lime: "border-lime-500 bg-lime-50 text-lime-900 dark:border-lime-400 dark:bg-lime-950/50 dark:text-lime-100",
  green: "border-green-500 bg-green-50 text-green-900 dark:border-green-400 dark:bg-green-950/50 dark:text-green-100",
  emerald: "border-emerald-500 bg-emerald-50 text-emerald-900 dark:border-emerald-400 dark:bg-emerald-950/50 dark:text-emerald-100",
  teal: "border-teal-500 bg-teal-50 text-teal-900 dark:border-teal-400 dark:bg-teal-950/50 dark:text-teal-100",
  cyan: "border-cyan-500 bg-cyan-50 text-cyan-900 dark:border-cyan-400 dark:bg-cyan-950/50 dark:text-cyan-100",
  sky: "border-sky-500 bg-sky-50 text-sky-900 dark:border-sky-400 dark:bg-sky-950/50 dark:text-sky-100",
  blue: "border-blue-500 bg-blue-50 text-blue-900 dark:border-blue-400 dark:bg-blue-950/50 dark:text-blue-100",
  indigo: "border-indigo-500 bg-indigo-50 text-indigo-900 dark:border-indigo-400 dark:bg-indigo-950/50 dark:text-indigo-100",
  violet: "border-violet-500 bg-violet-50 text-violet-900 dark:border-violet-400 dark:bg-violet-950/50 dark:text-violet-100",
  purple: "border-purple-500 bg-purple-50 text-purple-900 dark:border-purple-400 dark:bg-purple-950/50 dark:text-purple-100",
  fuchsia: "border-fuchsia-500 bg-fuchsia-50 text-fuchsia-900 dark:border-fuchsia-400 dark:bg-fuchsia-950/50 dark:text-fuchsia-100",
  pink: "border-pink-500 bg-pink-50 text-pink-900 dark:border-pink-400 dark:bg-pink-950/50 dark:text-pink-100",
  rose: "border-rose-500 bg-rose-50 text-rose-900 dark:border-rose-400 dark:bg-rose-950/50 dark:text-rose-100",
};

export const calloutIcon: Record<Color, string> = {
  slate: "text-slate-500 dark:text-slate-400",
  gray: "text-gray-500 dark:text-gray-400",
  zinc: "text-zinc-500 dark:text-zinc-400",
  neutral: "text-neutral-500 dark:text-neutral-400",
  stone: "text-stone-500 dark:text-stone-400",
  red: "text-red-500 dark:text-red-400",
  orange: "text-orange-500 dark:text-orange-400",
  amber: "text-amber-500 dark:text-amber-400",
  yellow: "text-yellow-500 dark:text-yellow-400",
  lime: "text-lime-500 dark:text-lime-400",
  green: "text-green-500 dark:text-green-400",
  emerald: "text-emerald-500 dark:text-emerald-400",
  teal: "text-teal-500 dark:text-teal-400",
  cyan: "text-cyan-500 dark:text-cyan-400",
  sky: "text-sky-500 dark:text-sky-400",
  blue: "text-blue-500 dark:text-blue-400",
  indigo: "text-indigo-500 dark:text-indigo-400",
  violet: "text-violet-500 dark:text-violet-400",
  purple: "text-purple-500 dark:text-purple-400",
  fuchsia: "text-fuchsia-500 dark:text-fuchsia-400",
  pink: "text-pink-500 dark:text-pink-400",
  rose: "text-rose-500 dark:text-rose-400",
};
